<template>
  <div class="container fluid">
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs12 sm6>
          <v-btn
            depressed
            :outline="channelFilter != 'all'"
            :color="channelFilter == 'all' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="channelFilter = 'all'"
            >{{ $t('All') }}</v-btn
          >
          <v-btn
            depressed
            :outline="channelFilter != 'facebook'"
            :color="channelFilter == 'facebook' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="channelFilter = 'facebook'"
          >
            <em class="fab fa-facebook-square mr-1" />
            {{ $t('Facebook') }}
          </v-btn>
          <v-btn
            depressed
            :outline="channelFilter != 'line'"
            :color="channelFilter == 'line' ? 'primary' : 'grey'"
            class="ma-0 mr-1 mb-1"
            @click="channelFilter = 'line'"
          >
            <em class="fab fa-line mr-1" />
            {{ $t('Line') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right">
          <div class="text-xs-right">
            <exportxlsx :promised-value="getXlsxData"></exportxlsx>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="mb-2">
      <date-filter
        v-model="selectedDate"
        :default-filter="'last_7_days'"
        @changeDate="onChangeDate"
      ></date-filter>
    </div>
    <div>
      <apexchart
        :key="chartKey"
        type="bar"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'

export default {
  components: {
    exportxlsx,
    DateFilter,
    DatePickerWithoutButton,
    apexchart: VueApexCharts
  },
  data() {
    return {
      timestamp: moment().format('x'),
      chartKey: 1,
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      channelFilter: 'all',
      filter: {
        app: ''
      },
      series: [
        {
          name: 'PDPA ',
          data: []
        }
      ],
      chartOptions: {
        colors: ['#F7856A', '#C4C4C4'],
        chart: {
          height: 500,
          type: 'bar'
        },
        plotOptions: {
          bar: {
            columnWidth: '30%',
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        xaxis: {
          categories: ['Agree', 'Disagree']
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return val.toFixed(0)
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' counts'
            }
          }
        }
      }
    }
  },
  mounted() {
    this.getPdpaReport()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        var data = await this.getPdpaReportExport()

        resolve(
          data.map((el) => {
            var pdpaStatus
            if (el.pdpa) {
              pdpaStatus = 'ยอมรับ'
            } else {
              pdpaStatus = 'ไม่ยอมรับ'
            }

            return {
              ชื่อลูกค้า: el.name,
              เพศ: el.gender,
              อายุ: el.ages,
              วันเดือนปีเกิด: el.dob ? moment(el.dob).format('DD/MM/YYYY') : '',
              เบอร์โทรศัพท์: el.phone_number,
              อีเมล: el.email,
              วันที่สมัครสมาชิก: el.register_timestamp
                ? moment(el.register_timestamp).format('DD/MM/YYYY')
                : '',
              // วันหมดอายุสมาชิก: el.expired_timestamp
              //   ? moment(el.expired_timestamp).format('DD/MM/YYYY')
              //   : '',
              // วันที่ต่ออายุสมาชิก: el.renew_timestamp
              //   ? moment(el.renew_timestamp).format('DD/MM/YYYY')
              //   : '',
              การยินยอม_PDPA: pdpaStatus
            }
          })
        )
      })
    },
    getPdpaReport() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid, // required
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }

        if (vm.series[0].data) {
          vm.series.data = []
        }

        vm.$store.dispatch('loading')
        api.getLamyPdpdReport(data, (err, response) => {
          vm.$store.dispatch('loading')

          if (err) {
            console.error(err)
            return
          }

          if (response.responsecode == 200) {
            var chartData = response.data[0]
            vm.series[0].data = Object.values(chartData)
            vm.chartKey++
            resolve(response.data)
          }
        })
      })
    },
    getPdpaReportExport() {
      return new Promise((resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid, // required
          app: vm.channelFilter,
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }
        vm.loading = true
        api.getLamyPdpdReportExport(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.loading = false
            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    onChangeDate() {
      this.getPdpaReport()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/lamy/PdpaReport.vue